// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__fKam3","dark":"dark","error-text":"Checkbox_error-text__JvR3f"};